import React from 'react';
import './Footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          © 2025 Sundeep Myneni. Made with ♥ in Cumming, GA.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
